import { render, staticRenderFns } from "./LightBoxAdd.vue?vue&type=template&id=48365976"
import script from "./LightBoxAdd?vue&type=script&lang=ts&external"
export * from "./LightBoxAdd?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports